import React, { useContext } from "react";
import SponsorContext from "../../../context/sponsor/SponsorContext";
import { Link, useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { FaTimesCircle } from "react-icons/fa";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import "./Sponsors.css";
import {
  createSponsor,
  getUploadedSponsorImage,
} from "../../../services/sponsors";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import IconButton from "@mui/material/IconButton";
import upload from "../../../assets/sponsors/upload.png";
import DialogBox from "../../../components/DialogBox";
import { useCallbackPrompt } from "../../../hooks/useCallbackPrompt";
import {
  buttonLinkStyle,
  rowStyles,
} from "../StudySetup/Visits/Questionnaires/EditVisitQuestionnaire";
import { handleBackNavigationGeneralFun } from "../../../components/helpers/helper";

const CreateSponsors = () => {
  const { sponsorCreation } = useContext(SponsorContext);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [sponsorName, setSponsorName] = React.useState("");
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [imgPreview, setImgPreview] = React.useState(null);
  const navigate = useNavigate();

  const [showDialog, setShowDialog] = React.useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showDialog);
  const [load, setLoad] = React.useState(false);

  const validationSchema = yup.object().shape({
    name: yup
      .string()
      .trim()
      .required("Name is required")
      .max(255, "Name must be at most 255 characters")
      .matches(
        /^[A-Za-z][A-Za-z0-9\s!@#$%^&*()_+=-]*$/,
        "Name must start with a letter and cannot start with a number or special character"
      ),
    file: yup.mixed().required("Image is required"),
  });

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const successToast = "sponsor-success";

  const notify = () =>
    toast.success("Sponsor Added Successfully", {
      // theme: "colored",
      toastId: "createSponsorSuccessToast",
    });

  const imageIsRequired = () =>
    toast.warn("Image is required", {
      // theme: "colored",
      toastId: "imageRequired",
    });

  const requestFailed = (msg) =>
    toast.error(`${msg}`, {
      // theme: "colored",
      toastId: "requestFailed",
    });

  const cancelSponsor = (e) => {
    e.preventDefault();

    if (showDialog) {
      const confirmExit = window?.confirm(
        "You have unsaved changes, Are you sure you want to leave?"
      );

      if (confirmExit) {
        navigate("/all-sponsors");
      }
    } else {
      navigate("/all-sponsors");
    }
  };

  // const onSubmit = async (data, e) => {
  //   e.preventDefault();
  //   try {
  //     setLoad(true);
  //     var name = data.name;
  //     console.log(selectedFile, "selectedFile");
  //     var fileUrl = selectedFile;
  //     if (!selectedFile) {
  //       imageIsRequired();
  //     } else {
  //       setShowDialog(false);
  //       const res = await createSponsor({
  //         name,
  //         fileUrl,
  //       });
  //       if (res.status) {
  //         navigate("/all-sponsors");
  //         notify();
  //       }
  //     }
  //   } catch (err) {
  //     console.log("submit error: ", err);
  //     requestFailed(err.message);
  //   } finally {
  //     setLoad(false);
  //   }
  // };

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      setLoad(true);

      // if (!imgPreview || !imgPreview[0]) {
      //   imageIsRequired();
      //   return;
      // }
      if (!selectedFile) {
        imageIsRequired();
        return;
      }

      setShowDialog(false);
      const fileUrl = selectedFile;

      const allowedFormats = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
      ];

      if (!allowedFormats.includes(selectedFile.type)) {
        toast.warn("Only JPEG, JPG, PNG, and WebP formats are allowed", {
          toastId: "invalidImageFormat",
        });
        return;
      }

      const imageRes = await getUploadedSponsorImage(fileUrl);

      // const res = await createSponsor({
      //   name: data.name,
      //   fileUrl: imgPreview[0], // Base64 image string
      // });

      // if (res.status) {
      //   navigate("/all-sponsors");
      //   notify();
      // }
      if (imageRes?.status === 200 && imageRes?.data) {
        const imagePath = imageRes.data.filePath;
        const res = await createSponsor({
          name: data.name,
          fileUrl: imagePath, // Base64 image string
        });
        if (res.status) {
          notify();
          navigate("/all-sponsors");
        } else {
          requestFailed();
        }
      }
    } catch (err) {
      console.log("submit error: ", err);
      requestFailed(err.message);
    } finally {
      setLoad(false);
    }
  };

  const removeImage = () => {
    setImgPreview(null);
    setSelectedFile(null);
  };

  const handleSponsorInput = (event) => {
    let name = event.target.value;
    if (name.length > 0 && name[0] === " ") {
      name = name.trimStart();
      event.target.value = name;
    }
    if (name) {
      setShowDialog(true);
      clearErrors("name");
    }
  };

  return (
    <>
      {load ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
            }}
          >
            <BeatLoader color="#3661eb" />
          </div>
        </>
      ) : (
        <div className="content-body">
          <DialogBox
            showDialog={showPrompt}
            confirmNavigation={confirmNavigation}
            cancelNavigation={cancelNavigation}
          />

          <p className="admin-link" style={{ fontWeight: "600" }}>
            <button
              style={buttonLinkStyle}
              onClick={(e) =>
                handleBackNavigationGeneralFun(
                  e,
                  showDialog,
                  "homepage",
                  navigate
                )
              }
            >
              Home
            </button>{" "}
            |{" "}
            <button
              style={buttonLinkStyle}
              onClick={(e) =>
                handleBackNavigationGeneralFun(
                  e,
                  showDialog,
                  "all-sponsors",
                  navigate
                )
              }
            >
              Sponsors
            </button>{" "}
            | <Link to="/create-sponsor">Add Sponsor</Link>
          </p>
          <p className="sponsor-heading">Add Sponsor</p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="uploadField">
              <label className="uploadInputLabel">
                Upload Image <span style={{ color: "red" }}>*</span>
              </label>
              <Row>
                <Col md={4} className="mt-3">
                  {imgPreview === null ? (
                    <>
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="label"
                      >
                        <input
                          hidden={true}
                          accept="image/*"
                          name="file"
                          type="file"
                          // {...register("file", { required: true })}
                          {...register("file", { required: true })}
                          onChange={(event) => {
                            var file = event.target.files[0];
                            const reader = new FileReader();
                            var url = reader.readAsDataURL(file);
                            reader.onloadend = function (e) {
                              setImgPreview([reader.result]);
                            };
                            setSelectedFile(file);
                            setShowDialog(true);
                          }}
                          // onChange={(event) => {
                          //   var file = event.target.files[0];
                          //   const reader = new FileReader();
                          //   var url = reader.readAsDataURL(file);
                          //   reader.onloadend = function (e) {
                          //     setImgPreview([reader.result]);
                          //   };

                          //   setSelectedFile(file);
                          //   setShowDialog(true);
                          // }}

                          // onChange={(event) => {
                          //   const file = event.target.files[0];
                          //   const reader = new FileReader();

                          //   reader.onloadend = function () {
                          //     setImgPreview([reader.result]); // reader.result is Base64 string
                          //   };

                          //   reader.readAsDataURL(file); // Trigger the read
                          //   setSelectedFile(file); // optional, for file name
                          //   setShowDialog(true);
                          // }}
                        />
                        <img
                          style={{
                            height: "200px",
                            objectFit: "contain",
                            width: "100%",
                          }}
                          src={upload}
                          className="uploadImg"
                        />
                      </IconButton>
                      <span style={{ color: "red", marginLeft: "1%" }}>
                        {errors.file?.message}
                      </span>
                    </>
                  ) : (
                    <>
                      <div className="relative inline-block">
                        <button
                          type="button"
                          className="absolute top-1 right-1 bg-transparent border-none cursor-pointer z-10"
                          onClick={() => removeImage()}
                        >
                          <FaTimesCircle className="text-red-500 text-xl" />
                        </button>
                        <img
                          src={imgPreview}
                          className="uploadImgAfter block max-w-full rounded-lg"
                          alt="Uploaded"
                        />
                      </div>
                      <span
                        className="text-red-600 ml-1"
                        style={{ color: "red" }}
                      >
                        {errors.file?.message}
                      </span>
                    </>
                  )}
                </Col>
              </Row>
            </div>
            <div className="uploadField">
              <label className="uploadInputLabel">
                Name <span style={{ color: "red" }}>*</span>
              </label>
              <Row>
                <Col md={6}>
                  <input
                    // defaultValue={sponsorName}
                    className="nameSponsorField"
                    type="text"
                    {...register("name", { required: true })}
                    onChange={handleSponsorInput}
                  />
                  <span style={{ color: "red", marginTop: "1%" }}>
                    {errors.name?.message}
                  </span>
                </Col>
              </Row>
              <Row style={rowStyles}>
                <Col md={8}></Col>
                <Col md={2}>
                  <div className="study-management-head-end">
                    <button
                      type="button"
                      onClick={(e) => {
                        cancelSponsor(e);
                      }}
                      className="study-management-cancel-btn"
                    >
                      Cancel
                    </button>
                  </div>
                </Col>
                <Col md={2}>
                  <div className="study-management-head-end">
                    <button
                      type="submit"
                      className="study-management-create-btn-md"
                    >
                      Add
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default CreateSponsors;
